import { Controller } from '@hotwired/stimulus'

// Edits a participant's work_schedule jsonb. Maintains 7 day rows; each day has
// a list of {start, end} HH:MM time intervals. On every change it serializes
// the current state into a hidden input so the controller can JSON.parse it.
export default class extends Controller {
  static targets = ['hidden', 'day', 'template']

  connect() {
    this.serialize()
  }

  add(event) {
    event.preventDefault()
    const dayKey = event.currentTarget.dataset.day
    const dayEl = this.dayTargets.find((el) => el.dataset.day === dayKey)
    const intervalsEl = dayEl.querySelector('[data-intervals]')
    intervalsEl.appendChild(this.templateTarget.content.cloneNode(true))
    this.serialize()
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest('[data-interval]').remove()
    this.serialize()
  }

  serialize() {
    const schedule = {}
    this.dayTargets.forEach((dayEl) => {
      const day = dayEl.dataset.day
      const intervals = []
      dayEl.querySelectorAll('[data-interval]').forEach((row) => {
        const start = row.querySelector('[data-time="start"]').value
        const end = row.querySelector('[data-time="end"]').value
        if (start && end) intervals.push({ start, end })
      })
      schedule[day] = intervals
    })
    this.hiddenTarget.value = JSON.stringify(schedule)
  }
}
